jQuery(document).ready(function(){
    jQuery('.organization-name').click(function(){
        if(jQuery(this).parent().hasClass('filtered')){
            jQuery(this).parent().toggleClass('filtered');
        }else{
            jQuery(this).parent().toggleClass('open');
        }
        var expanded = false;
        if(jQuery(this).parent().hasClass('open') || jQuery(this).parent().hasClass('filtered')){
            expanded = true;
        }
        jQuery(this).attr('aria-expanded', expanded);
    });
    jQuery('#writer-tag-cloud .tag').click(function(){
        var id = jQuery(this).data('id');
        jQuery(this).toggleClass('active');
        filterWriters();
    });
    jQuery("#writer-search").keyup(function() {
        filterWriters();
    });
    jQuery('#writer-tag-cloud .tags-visibility-button').click(function(){
        if(jQuery(this).hasClass('more')){
            jQuery(this).parent().find('.more').hide();
            jQuery(this).parent().find('.less').show().focus();
            if(jQuery(this).parent().hasClass('writer-tags-visibility-mobile')){
                jQuery('#writer-tag-cloud').removeClass('hide-tag-mobile');
            }else{
                jQuery('#writer-tag-cloud').removeClass('hide-tag');
            }
        }else{
            jQuery(this).parent().find('.more').show().focus();
            jQuery(this).parent().find('.less').hide();
            jQuery('#writer-tag-cloud').addClass('hide-tag');
            if(jQuery(this).parent().hasClass('writer-tags-visibility-mobile')){
                jQuery('#writer-tag-cloud').addClass('hide-tag-mobile');
            }else{
                jQuery('#writer-tag-cloud').addClass('hide-tag');
            }
        }
    });
});

function filterWriters(){
    var selectedTags = [];
    jQuery('#writer-tag-cloud .tag.active').each(function(){
        selectedTags.push(jQuery(this).data('id'));
    });
    if(selectedTags.length == 0){
        selectedTags = false;
    }

    var search = false;
    var searchText = jQuery('#writer-search').val().toLowerCase();
    if(searchText){
        search = searchText.split(' ');
    }

    if(selectedTags || search){
        jQuery(".organization-container").hide();
        jQuery(".cell.writer").hide();
        jQuery('.cell.writer').each(function(){
            var tagFound = false;
            if(selectedTags){
                var tags = String(jQuery(this).data('tags'));
                if(tags != ''){
                    tags = tags.split(' ');
                    for(var i in tags){
                        tags[i] = parseInt(tags[i]);
                    }
                    for(var i = 0; i < selectedTags.length; i++){
                        if(tags.includes(selectedTags[i])){
                            tagFound = true;
                            break;
                        }
                    }
                }
            }
            var keywordFound = false;
            if(search){
                var keywords = jQuery(this).attr('name').toLowerCase();
                for(var i = 0; i < search.length; i++){
                    if(keywords.indexOf(search[i]) > -1){
                        keywordFound = true;
                        break;
                    }
                }
            }
            if(search && selectedTags){
                if(tagFound && keywordFound){
                    jQuery(this).show();
                    jQuery(this).closest('.organization-container').show().addClass('filtered');
                    jQuery(this).closest('.organization-container').find('.organization-name').attr('aria-expanded', true);
                }
            }else{
                if(tagFound || keywordFound){
                    jQuery(this).show();
                    jQuery(this).closest('.organization-container').show().addClass('filtered');
                    jQuery(this).closest('.organization-container').find('.organization-name').attr('aria-expanded', true);
                }
            }
        });
    }else{
        jQuery(".organization-container").show().removeClass('filtered');
        jQuery('.organization-container').find('.organization-name').attr('aria-expanded', true);
        jQuery(".cell.writer").show();
    }
}

jQuery(document).ready(function(){
    var hash = window.location.hash;
    if(hash){
        var id = hash.substring(1);
        var section = document.getElementById(id);
        if(section && jQuery(section).hasClass('organization-container')){
            jQuery(section).addClass('open');
            jQuery(section).find('.organization-name').attr('aria-expanded', true);
        }
    }
});
